var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',[_c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs12":""}},[_c('span',[_vm._v("\n      "+_vm._s(new Date().getFullYear())+" —\n      "),_c('strong',[_vm._v("Nutris")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }